export default {
  background_image: 'Immagine di sfondo',
  file_too_large: 'Il file è troppo grande. La dimensione massima è {{max}} MB.',
  upload_failed: 'Caricamento non riuscito. Riprova.',
};
